module.exports = "/lucky-balls/img/drawnballs/brown.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/brown.png
// module id = 1010
// module chunks = 0